import { translateFn } from '../../../../../../../utils/translator.helper';
import { ValidationResult } from '../../../../../../../ui/gzForm/formField/types/form-validator';
import {
  ContentControlTrafficExclusion,
  ContentControlTrafficExclusionType,
} from '@nirvana/shared/dtos/types/policies/common';
import { IpValidator } from '../../../../../../../ui/gzForm/validators/ip.validator';
import { wildcard } from '../../../../../../common/policyPanel/uiSettings/utils/validators/wildcard.validators';

// maximum entity length
export const MAX_LENGTH = 260;

// validate entity by type
export async function validateEntityByType(
  type: ContentControlTrafficExclusionType,
  entity: string
): Promise<ValidationResult> {
  switch (type) {
    case ContentControlTrafficExclusionType.IP:
      return await IpValidator(translateFn('Invalid IP/mask'), true, true)(entity);
    case ContentControlTrafficExclusionType.URL:
      return wildcard(entity, translateFn('Invalid URL'));
    case ContentControlTrafficExclusionType.APPLICATION:
      return wildcard(entity, translateFn('Invalid application path'));
    default:
      return { valid: true };
  }
}

// validate duplicates
export function validateDuplicates(
  exclusionItem: ContentControlTrafficExclusion,
  exclusionsInGrid: ContentControlTrafficExclusion[]
): ValidationResult {
  const exclusionEntity = exclusionItem.entity.toLowerCase();
  const hasDuplicates = exclusionsInGrid.some(
    (exclusionInGrid: ContentControlTrafficExclusion) =>
      exclusionInGrid.type === exclusionItem.type && exclusionInGrid.entity.toLowerCase() === exclusionEntity
  );

  if (hasDuplicates) {
    return {
      valid: false,
      error: translateFn('The entry already exists.'),
    };
  }

  return {
    valid: true,
  };
}
